import { MessagingTemplateDetailsState } from "@idw-types/state/messaging-template-details-state";
import { getMessagingTemplateDetailsState } from "@redux/selectors/root-selectors";
import { createSelector } from "reselect";

export const getMessagingTemplateDetailsDataState = createSelector(getMessagingTemplateDetailsState, (state: MessagingTemplateDetailsState) => {
    return {
        isLoadingMessagingTemplate: state.messagingTemplate.isLoading,
        messagingTemplate: state.messagingTemplate.messagingTemplate
    };
});